export default "__VITE_ASSET__NCDB3C1L__"